import React, { useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useSelector } from 'react-redux';
import client from '../../api';

const MySwal = withReactContent(Swal);

const FormUploadPo = props => {
  const { user } = useSelector(state => state.auth);
  const { orderId, onClose, refresh } = props;
  const [poNumber, setPoNumber] = useState('');
  const [poFile, setPoFile] = useState(null);
  const [poNote, setPoNote] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const savePo = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('po_number', poNumber);
    formData.append('po_file', poFile);
    formData.append('po_note', poNote);
    try {
      setSubmitting(true);
      const order = await client.patch(
        `/api/customers/orders/${orderId}/upload-po`,
        formData,
        {
          headers: {
            'Content-Type': 'mulitpart/form-data',
            Authorization: `Bearer ${user.data.token}`
          }
        }
      );
      if (order.status === 200) {
        MySwal.fire({
          title: <strong>Berhasil!</strong>,
          html: <i>File PO berhasil di upload!</i>,
          icon: 'success'
        });
        onClose();
        refresh();
      }
    } catch (error) {
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response.data.msg
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className='sb-form' onSubmit={savePo}>
      <div className='sb-form__field'>
        <label className='sb-form__label' htmlFor='po-number'>
          PO Number <span className='sb-form__required'>*</span>
        </label>
        <input
          id='po-number'
          className='sb-form__control'
          type='text'
          placeholder='Masukkan Nomor PO'
          value={poNumber}
          onChange={e => setPoNumber(e.target.value)}
          required
        />
      </div>

      <div className='sb-form__field'>
        <label className='sb-form__label' htmlFor='po-file'>
          PO File <span className='sb-form__required'>*</span>
        </label>
        <input
          id='po-file'
          className='sb-form__control sb-form__control--file'
          type='file'
          accept='.pdf,.png,.jpg,.jpeg'
          onChange={e => setPoFile(e.target.files[0])}
          required
        />
        <p className='sb-form__helper'>*Format file pdf, png, jpg. Max 10 Mb</p>
      </div>

      <div className='sb-form__field'>
        <label className='sb-form__label' htmlFor='po-note'>
          PO Note <span className='sb-form__required'>*</span>
        </label>
        <textarea
          id='po-note'
          className='sb-form__control sb-form__control--textarea'
          rows={4}
          placeholder='Catatan'
          value={poNote}
          onChange={e => setPoNote(e.target.value)}
          required
        />
      </div>

      <div className='sb-form__actions'>
        <button
          type='button'
          className='sb-btn sb-btn--neutral'
          onClick={onClose}
          disabled={submitting}>
          Batal
        </button>
        <button
          type='submit'
          className='sb-btn sb-btn--primary'
          disabled={submitting}>
          {submitting ? 'Mengunggah...' : 'Upload'}
        </button>
      </div>
    </form>
  );
};

export default FormUploadPo;
